'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactJss = require('react-jss');
var _reactJss2 = _interopRequireDefault(_reactJss);
var _moment = require('moment');
var _moment2 = _interopRequireDefault(_moment);
var _reactI18next = require('react-i18next');
var _ResponsiveModes = require('../constants/ResponsiveModes');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var urlFixed = function urlFixed(url) {
  if (!/^https?:\/\//i.test(url)) return 'http://' + url;
  return url;
};
var styles = {
  sponsor: {
    padding: function padding(_ref) {
      var responsiveMode = _ref.responsiveMode;
      return responsiveMode === _ResponsiveModes.MOBILE ? 0 : '0 32px 16px 32px';
    }
  },
  title: {
    fontWeight: 'bold',
    fontSize: 18,
    color: '#851486',
    margin: function margin(_ref2) {
      var responsiveMode = _ref2.responsiveMode;
      return responsiveMode === _ResponsiveModes.MOBILE ? '0 0 52px 0' : '0 0 20px 0';
    }
  },
  separator: {
    margin: function margin(_ref3) {
      var responsiveMode = _ref3.responsiveMode;
      return responsiveMode === _ResponsiveModes.MOBILE ? '16px -16px 24px -16px' : '20px -48px 32px -48px';
    },
    border: '1px solid rgb(221 221 221)'
  },
  card: {
    padding: function padding(_ref4) {
      var responsiveMode = _ref4.responsiveMode;
      return responsiveMode === _ResponsiveModes.MOBILE ? 16 : 24;
    },
    boxSizing: 'border-box',
    boxShadow: '0 3px 6px rgba(0, 0, 0, 0.16)',
    borderRadius: 10,
    backgroundColor: 'white',
    position: 'relative',
    overflow: 'hidden',
    marginBottom: 46
  },
  cardContent: {
    display: 'flex',
    alignItems: 'center'
  },
  logoWrapper: {
    width: 100
  },
  logo: {
    width: '100%'
  },
  verticalDivider: {
    height: 52,
    borderLeft: '1px solid #D4D3D4',
    margin: '0 32px 0 16px'
  },
  name: {
    fontWeight: 'bold',
    fontSize: 14,
    color: '#736A73',
    textTransform: 'capitalize',
    margin: 0
  },
  website: {
    color: '#851486',
    textDecoration: 'none',
    fontSize: 12,
    fontWeight: 'bold'
  },
  subtitle: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#555555'
  },
  text: {
    marginTop: 24,
    fontSize: 14,
    color: '#736A73'
  }
};
var SponsorModalContent = function (_Component) {
  _inherits(SponsorModalContent, _Component);
  function SponsorModalContent(props) {
    _classCallCheck(this, SponsorModalContent);
    return _possibleConstructorReturn(this, (SponsorModalContent.__proto__ || Object.getPrototypeOf(SponsorModalContent)).call(this, props));
  }
  _createClass(SponsorModalContent, [{
    key: 'render',
    value: function render() {
      if (this.props.i18n.language === 'es') _moment2.default.updateLocale('es', {
        ordinal: '%d'
      });
      var _props = this.props,
        classes = _props.classes,
        sponsor = _props.sponsor,
        t = _props.t,
        responsiveMode = _props.responsiveMode,
        eventUri = _props.eventUri;
      return _react2.default.createElement('div', {
        className: classes.sponsor
      }, _react2.default.createElement('p', {
        className: classes.title
      }, t('sponsors.modalTitle')), _react2.default.createElement('hr', {
        className: classes.separator
      }), _react2.default.createElement('div', {
        className: classes.card
      }, _react2.default.createElement('div', {
        className: classes.cardContent
      }, _react2.default.createElement('div', {
        className: classes.logoWrapper
      }, _react2.default.createElement('img', {
        className: classes.logo,
        src: sponsor.logo.medium
      })), _react2.default.createElement('div', {
        className: classes.verticalDivider
      }), _react2.default.createElement('div', null, _react2.default.createElement('p', {
        className: classes.name
      }, sponsor.name), !!sponsor.website && _react2.default.createElement('a', {
        className: classes.website,
        href: urlFixed(sponsor.website),
        target: '_blank'
      }, sponsor.website)))), !!sponsor && !!sponsor.description && _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement('p', {
        className: classes.subtitle
      }, t('sponsors.companyDescription')), _react2.default.createElement('div', {
        className: classes.text,
        dangerouslySetInnerHTML: {
          __html: sponsor.description
        }
      })));
    }
  }]);
  return SponsorModalContent;
}(_react.Component);
exports.default = (0, _reactJss2.default)(styles)((0, _reactI18next.translate)('Misc')(SponsorModalContent));